<template>
  <page-title pageTitle="Supplier Invoice" title="View Supplier Invoice" />
  <distributor-invoices-form
    v-if="distributorInvoice.id"
    :distributorInvoice="distributorInvoice"
  />
  <div v-else class="card">
    <LoadingModal v-if="loading" />
    <div v-else-if="error" class="card-body">
      {{ error }}
    </div>
    <div v-else class="card-body">The Supplier Invoice doesn't exist</div>
  </div>
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import DistributorInvoicesForm from "@/components/distributorInvoices/DistributorInvoicesForm";
import LoadingModalComponent from "@/components/utils/LoadingModal";

export default {
  name: "DistributorInvoiceView",
  components: {
    PageTitle: PageTitleComponent,
    DistributorInvoicesForm: DistributorInvoicesForm,
    LoadingModal: LoadingModalComponent,
  },
  data() {
    return {
      id: -1,
    };
  },
  computed: {
    distributorInvoice() {
      return this.$store.getters.distributorInvoice;
    },
    error() {
      return this.$store.getters.distributorInvoicesError;
    },
    loading() {
      return this.$store.getters.distributorInvoicesLoading;
    },
  },
  async created() {
    this.id = parseInt(this.$route.params.id);
    await this.$store.dispatch("getDistributorInvoice", this.id);
  },
  unmounted() {
    this.$store.dispatch("resetDistributorInvoices", this.id);
  },
};
</script>

<style scoped></style>
